module.exports = "https://www.gc-pro.gnp.com.mx/fa5460e2d8708733ac1922010ebeaa46.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/retenciones/02.png
// module id = 1060
// module chunks = 0 1